(function(){
  if(window.BGG) return;
  var D = document, REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2,.7,.2,1)', FLY = 'cubic-bezier(.22,.8,.2,1)';
  var wide = window.matchMedia('(min-width: 1024px)');
  var ICON = { prev:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 6-6 6 6 6"/></svg>', next:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>', x:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' };
  function clamp(v, a, b){ return Math.max(a, Math.min(b, v)); }
  function arr(n){ return [].slice.call(n); }
  function sized(url, w){ if(!url) return url; return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function imgUrl(img){ var ss = img.getAttribute('srcset'); var u = ss ? ss.split(',').pop().trim().split(' ')[0] : (img.currentSrc || img.src); return u.indexOf('//') === 0 ? 'https:' + u : u; }

  /* ================= page ================= */
  function initGallery(g){
    if(g.classList.contains('bgg')) return;
    var slider = g.querySelector('slider-element'), dots = g.querySelector('media-dots');
    if(!slider) return;
    g.classList.add('bgg');
    var holder = slider.parentElement; if(getComputedStyle(holder).position === 'static') holder.style.position = 'relative';
    /* compteur */
    var count = D.createElement('div'); count.className = 'bgg-count'; count.setAttribute('aria-hidden', 'true');
    count.innerHTML = '<span class="n"><span>1</span></span><span>/ <b style="font-weight:600" class="t">1</b></span>';
    holder.appendChild(count);
    var shown = 1;
    function items(){ return slider.itemsToShow ? slider.itemsToShow : arr(slider.querySelectorAll('.product__media')).filter(function(e){ return e.clientWidth > 0; }); }
    function page(){ var it = items(), w = it.length > 1 ? it[1].offsetLeft - it[0].offsetLeft : slider.clientWidth; return w ? Math.round(Math.abs(slider.scrollLeft) / w) + 1 : 1; }
    function roll(n, dir){
      var box = count.querySelector('.n');
      arr(box.children).forEach(function(c, k, all){ if(k < all.length - 1) c.remove(); });
      var old = box.firstChild, nu = D.createElement('span'); nu.textContent = n;
      if(REDUCE || !old || !old.animate){ box.innerHTML = ''; box.appendChild(nu); return; }
      old.getAnimations().forEach(function(a){ a.cancel(); });
      box.appendChild(nu); box.style.width = Math.max(old.offsetWidth, nu.offsetWidth) + 'px';
      var dy = dir > 0 ? 18 : -18;
      old.animate([{ transform:'translateY(0)', opacity:1 }, { transform:'translateY(' + (-dy) + 'px)', opacity:0 }], { duration:300, easing:EASE, fill:'forwards' });
      var an = nu.animate([{ transform:'translateY(' + (dy - 18) + 'px)', opacity:0 }, { transform:'translateY(-18px)', opacity:1 }], { duration:300, easing:EASE, fill:'forwards' });
      an.onfinish = function(){ if(old.parentNode) old.remove(); an.cancel(); box.style.width = ''; };
    }
    function syncCount(){
      var n = items().length, p = clamp(page(), 1, Math.max(1, n));
      count.hidden = n < 2; count.querySelector('.t').textContent = n;
      if(p !== shown){ roll(p, p > shown ? 1 : -1); shown = p; }
    }
    /* cadre des vignettes */
    var ring = null;
    function placeRing(instant){
      if(!dots || !wide.matches) return;
      var cur = dots.querySelector('.product__thumbnail[aria-current="true"]');
      if(!ring){ ring = D.createElement('span'); ring.className = 'bgg-ring'; g.appendChild(ring); if(getComputedStyle(g).position === 'static') g.style.position = 'relative'; instant = true; }
      if(!cur || !cur.offsetWidth){ ring.style.opacity = 0; return; }
      var gr = g.getBoundingClientRect(), r = cur.getBoundingClientRect(), dr = dots.getBoundingClientRect();
      var hidden = r.bottom < dr.top + 4 || r.top > dr.bottom - 4 || r.right < dr.left + 4 || r.left > dr.right - 4;
      if(instant || REDUCE) ring.style.transition = 'none';
      ring.style.opacity = hidden ? 0 : 1;
      ring.style.left = (r.left - gr.left) + 'px'; ring.style.top = (r.top - gr.top) + 'px'; ring.style.width = r.width + 'px'; ring.style.height = r.height + 'px';
      if(instant || REDUCE){ ring.getBoundingClientRect(); ring.style.transition = ''; }
    }
    if(dots){
      new MutationObserver(function(){ placeRing(false); }).observe(dots, { subtree:true, attributes:true, attributeFilter:['aria-current', 'hidden'] });
      var sc; dots.addEventListener('scroll', function(){ if(sc) return; sc = requestAnimationFrame(function(){ sc = null; placeRing(true); }); }, { passive:true });
      /* survol des vignettes = aperçu, seulement si la souris bouge vraiment (pas quand la colonne défile sous elle) */
      var hovT = null, quiet = 0;
      /* la colonne ne se recentre pas pendant un aperçu au survol (méthode du thème appelée sinon, même si l'élément est mis à niveau après nous) */
      dots.transitionTo = function(i, imm){ if(performance.now() < quiet) return; var fn = Object.getPrototypeOf(this).transitionTo; if(typeof fn === 'function') return fn.call(this, i, imm); };
      dots.addEventListener('pointermove', function(e){
        if(e.pointerType !== 'mouse' || !wide.matches || !(e.movementX || e.movementY)) return;
        var t = e.target.closest('.product__thumbnail'); clearTimeout(hovT); if(!t) return;
        hovT = setTimeout(function(){
          var i = parseInt(t.getAttribute('data-index'), 10); if(!i || i === page() || typeof slider.select !== 'function') return;
          quiet = performance.now() + 900;   /* la colonne ne se recentre pas pendant un aperçu au survol */
          dots.querySelectorAll('.product__thumbnail').forEach(function(x){ x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
          slider.select(i);
        }, 90);
      });
      dots.addEventListener('pointerleave', function(){ clearTimeout(hovT); });
    }
    slider.addEventListener('slider:change', function(){ syncCount(); placeRing(false); });
    var st; slider.addEventListener('scroll', function(){ clearTimeout(st); st = setTimeout(syncCount, 60); }, { passive:true });
    D.addEventListener('variant:change', function(){ setTimeout(function(){ shown = 0; syncCount(); placeRing(true); }, 120); });
    window.addEventListener('resize', function(){ placeRing(true); }, { passive:true });
    wide.addEventListener && wide.addEventListener('change', function(){ placeRing(true); });

    /* glisser l'image à la souris (ordinateur) ; au doigt, le défilement natif du thème suffit */
    var drag = null, justDragged = 0;
    slider.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse' || e.button !== 0 || !wide.matches) return;
      var it = items(); if(it.length < 2) return;
      drag = { x0:e.clientX, y0:e.clientY, left:slider.scrollLeft, moved:false, hist:[[e.clientX, performance.now()]], id:e.pointerId };
    });
    window.addEventListener('pointermove', function(e){
      if(!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x0;
      if(!drag.moved){ if(Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(e.clientY - drag.y0)) return; drag.moved = true; slider.classList.add('is-dragging'); }
      slider.scrollLeft = drag.left - dx;
      drag.hist.push([e.clientX, performance.now()]); if(drag.hist.length > 5) drag.hist.shift();
    });
    window.addEventListener('pointerup', function(e){
      if(!drag || e.pointerId !== drag.id) return;
      var d = drag; drag = null; if(!d.moved) return;
      justDragged = performance.now();
      var h = d.hist, a = h[0], b = h[h.length - 1], vel = (b[0] - a[0]) / Math.max(1, b[1] - a[1]);
      var it = items(), w = it.length > 1 ? it[1].offsetLeft - it[0].offsetLeft : slider.clientWidth;
      var start = Math.round(d.left / w) + 1, dx = b[0] - d.x0, target = start;
      if(dx < -w * .18 || vel < -.45) target = start + 1; else if(dx > w * .18 || vel > .45) target = start - 1;
      target = clamp(target, 1, it.length);
      slider.classList.remove('is-dragging');
      slider.scrollTo({ left:(target - 1) * w, behavior:REDUCE ? 'auto' : 'smooth' });
    });
    g.addEventListener('click', function(e){ if(performance.now() - justDragged < 350){ e.preventDefault(); e.stopImmediatePropagation(); } }, true);
    syncCount(); setTimeout(function(){ placeRing(true); syncCount(); }, 400);
    g._bgg = { slider:slider, items:items, page:page };
  }

  /* ================= visionneuse ================= */
  var vw = null, st = null;
  function build(){
    if(vw) return;
    vw = D.createElement('div'); vw.className = 'bgg-vw'; vw.setAttribute('role', 'dialog'); vw.setAttribute('aria-modal', 'true'); vw.setAttribute('aria-label', 'Images du produit en plein écran');
    vw.innerHTML = '<div class="bgg-bd"></div><div class="top"><span class="vc"></span><button class="x" type="button" aria-label="Fermer">' + ICON.x + '</button></div>' +
      '<div class="vstage"><div class="vtrack"></div></div>' +
      '<button class="varr prev" type="button" aria-label="Image précédente">' + ICON.prev + '</button><button class="varr next" type="button" aria-label="Image suivante">' + ICON.next + '</button>' +
      '<div class="bot"></div><div class="vpills"></div><div class="hint">Glisser vers le bas pour fermer</div>';
    D.body.appendChild(vw);
    vw.querySelector('.x').addEventListener('click', function(){ close(); });
    vw.querySelector('.varr.prev').addEventListener('click', function(){ vGo(st.i - 1); });
    vw.querySelector('.varr.next').addEventListener('click', function(){ vGo(st.i + 1); });
    vw.querySelector('.bot').addEventListener('click', function(e){ var b = e.target.closest('button'); if(b) vGo(+b.dataset.i); });
    D.addEventListener('keydown', function(e){ if(!st) return; if(e.key === 'Escape') close(); if(e.key === 'ArrowRight') vGo(st.i + 1); if(e.key === 'ArrowLeft') vGo(st.i - 1); if(e.key === 'Tab') trap(e); });
    /* 04/10 r3 (jury a11y) : pop-up modale, le focus reste dedans (Tab / Maj+Tab bouclent sur ses boutons visibles ; un focus qui sort y revient) */
    D.addEventListener('focusin', function(e){ if(st && !vw.contains(e.target)){ var f = tabbables(); if(f.length) f[0].focus({ preventScroll:true }); } });
    gestures();
    window.addEventListener('resize', function(){ if(st) vSetX(-st.i * VW()); });
  }
  function q(s){ return vw.querySelector(s); }
  function qa(s){ return arr(vw.querySelectorAll(s)); }
  function VW(){ return q('.vstage').clientWidth; }
  function vSetX(v){ st.x = v; q('.vtrack').style.transform = 'translate3d(' + v + 'px,0,0)'; }
  function vSlide(i, dur){
    var from = st.x, to = -i * VW(); cancelAnimationFrame(vSlide.raf);
    if(REDUCE || dur === 0){ vSetX(to); return; }
    var t0 = performance.now(); dur = dur || 480;
    (function step(t){ var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 4); vSetX(from + (to - from) * e); if(k < 1) vSlide.raf = requestAnimationFrame(step); })(t0);
  }
  function vImg(i){ return qa('.vsl img')[i]; }
  function zw(i){ return qa('.vsl .zw')[i]; }
  function vGo(i, dur){
    if(!st) return;
    i = clamp(i, 0, st.list.length - 1); if(st.z.s > 1) setZoom(1, 0, 0, true);
    st.i = i; vSlide(i, dur);
    qa('.vsl').forEach(function(s, j){ s.classList.toggle('on', j === i); });
    q('.vc').textContent = (i + 1) + ' / ' + st.list.length;
    qa('.bot button').forEach(function(b, j){ b.classList.toggle('on', j === i); });
    qa('.vpills span').forEach(function(b, j){ b.classList.toggle('on', j === i); });
    q('.varr.prev').disabled = i === 0; q('.varr.next').disabled = i === st.list.length - 1;
    /* la fiche suit derrière (comme la visionneuse du thème) */
    var s = st.g._bgg.slider; if(typeof s.select === 'function') s.select(st.list[i].page, true);
    [i, i - 1, i + 1].forEach(function(k){ hd(vImg(k)); });
  }
  /* version HD chargée à part, puis échangée sans saut (mêmes proportions) */
  function hd(im){
    if(!im || !im.dataset.hd || im.dataset.hdOn) return; im.dataset.hdOn = '1';
    var pre = new Image(); pre.onload = function(){ im.src = pre.src; }; pre.src = im.dataset.hd;
  }
  function flyRects(srcUrl, r0, r1, dur, cb){
    var f = D.createElement('img'); f.className = 'bgg-fly'; f.src = srcUrl; D.body.appendChild(f);
    f.style.left = r1.left + 'px'; f.style.top = r1.top + 'px'; f.style.width = r1.width + 'px'; f.style.height = r1.height + 'px';
    var s0 = Math.min(r0.width / r1.width, r0.height / r1.height);
    var dx = r0.left + (r0.width - r1.width * s0) / 2 - r1.left, dy = r0.top + (r0.height - r1.height * s0) / 2 - r1.top;
    var an = f.animate([{ transform:'translate(' + dx + 'px,' + dy + 'px) scale(' + s0 + ')' }, { transform:'none' }], { duration:dur, easing:FLY, fill:'forwards' });
    an.onfinish = function(){ cb && cb(); requestAnimationFrame(function(){ f.remove(); }); };
  }
  /* rectangle réellement occupé par l'image (object-fit: contain) dans son cadre */
  function contentRect(img){
    var r = img.getBoundingClientRect(), nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height;
    var fit = getComputedStyle(img).objectFit;
    if(fit !== 'contain' || !nw || !nh) return r;
    var s = Math.min(r.width / nw, r.height / nh), w = nw * s, h = nh * s;
    return { left:r.left + (r.width - w) / 2, top:r.top + (r.height - h) / 2, width:w, height:h };
  }
  function tabbables(){ return [].filter.call(vw.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'), function(b){ return !b.disabled && b.getClientRects().length > 0 && getComputedStyle(b).visibility !== 'hidden'; }); }
  function trap(e){
    var f = tabbables(), i = f.indexOf(D.activeElement);
    if(!f.length){ e.preventDefault(); return; }
    if(e.shiftKey){ if(i <= 0){ e.preventDefault(); f[f.length - 1].focus({ preventScroll:true }); } }
    else if(i === -1 || i === f.length - 1){ e.preventDefault(); f[0].focus({ preventScroll:true }); }
  }
  function open(g, sliderIndex){
    build();
    var it = g._bgg.items(), list = [];
    it.forEach(function(el, k){ if(el.getAttribute('data-media-type') === 'image'){ var im = el.querySelector('img'); if(im) list.push({ el:el, img:im, page:k + 1, url:imgUrl(im), alt:im.getAttribute('alt') || '', w:+im.getAttribute('width') || im.naturalWidth || 1000, h:+im.getAttribute('height') || im.naturalHeight || 1000 }); } });
    if(!list.length) return false;
    var start = 0; list.forEach(function(x, k){ if(x.page === sliderIndex + 1) start = k; });
    st = { g:g, list:list, i:start, x:0, z:{ s:1, x:0, y:0 } };
    var esc = function(s){ return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };
    q('.vtrack').innerHTML = list.map(function(x, k){ return '<div class="vsl" data-i="' + k + '"><div class="zw"><img src="' + esc(x.img.currentSrc || sized(x.url, 1100)) + '" data-hd="' + esc(sized(x.url, 2000)) + '" width="' + x.w + '" height="' + x.h + '" alt="' + esc(x.alt) + '" draggable="false"></div></div>'; }).join('');
    q('.bot').innerHTML = list.map(function(x, k){ return '<button type="button" data-i="' + k + '" aria-label="Image ' + (k + 1) + '"><img src="' + esc(sized(x.url, 200)) + '" alt="" draggable="false"></button>'; }).join('');
    q('.vpills').innerHTML = list.map(function(){ return '<span></span>'; }).join('');
    vw.classList.toggle('is-m', !wide.matches);
    vw.classList.remove('ready', 'zoomed'); vw.classList.add('open'); D.documentElement.classList.add('bgg-open'); D.documentElement.style.overflow = 'hidden';
    st.lastFocus = D.activeElement;
    vGo(start, 0);
    var srcImg = list[start].img, r0 = contentRect(srcImg), target = vImg(start);
    target.style.visibility = 'hidden';
    var bg = q('.bgg-bd');
    var done = function(){ target.style.visibility = ''; vw.classList.add('ready'); q('.x').focus({ preventScroll:true }); if(!wide.matches){ var h = q('.hint'); h.classList.add('on'); setTimeout(function(){ h.classList.remove('on'); }, 1800); } };
    var go2 = function(){
      if(!st || go2.ran) return; go2.ran = true;
      bg.animate([{ opacity:0 }, { opacity:1 }], { duration:REDUCE ? 0 : 380, easing:EASE, fill:'forwards' });
      var r1 = target.getBoundingClientRect();
      if(REDUCE || !r1.width || !r0.width){ done(); return; }
      flyRects(srcImg.currentSrc || srcImg.src, r0, r1, 480, done);
    };
    requestAnimationFrame(go2);
    return true;
  }
  function close(fromRect){
    if(!st) return;
    var s = st; st = null;
    var g = s.g, item = s.list[s.i], dest = item.img;
    if(typeof g._bgg.slider.select === 'function') g._bgg.slider.select(item.page, true);
    var target = vImg(s.i), r0 = fromRect || target.getBoundingClientRect();
    vw.classList.remove('ready');
    var bg = q('.bgg-bd');
    var finish = function(){ vw.classList.remove('open', 'zoomed'); D.documentElement.classList.remove('bgg-open'); D.documentElement.style.overflow = ''; dest.style.visibility = ''; bg.style.opacity = ''; bg.getAnimations().forEach(function(a){ a.cancel(); }); if(s.lastFocus && s.lastFocus.focus) try{ s.lastFocus.focus({ preventScroll:true }); }catch(_){} };
    if(REDUCE){ finish(); return; }
    requestAnimationFrame(function(){
      var r1 = contentRect(dest);
      bg.animate([{ opacity:getComputedStyle(bg).opacity }, { opacity:0 }], { duration:340, easing:EASE, fill:'forwards' });
      target.style.visibility = 'hidden'; dest.style.visibility = 'hidden';
      if(!r1.width || r1.bottom < 0 || r1.top > window.innerHeight){ finish(); return; }
      flyRects(target.currentSrc || target.src, r0, r1, 420, finish);
    });
  }

  /* zoom et gestes dans la visionneuse */
  function bounds(s){
    var im = vImg(st.i), w = im.offsetWidth * s, h = im.offsetHeight * s, vs = q('.vstage');
    return { x:Math.max(0, (w - Math.min(vs.clientWidth, im.offsetWidth)) / 2), y:Math.max(0, (h - Math.min(vs.clientHeight, im.offsetHeight)) / 2) };
  }
  function applyZoom(animate){
    var el = zw(st.i), t = 'translate(' + st.z.x + 'px,' + st.z.y + 'px) scale(' + st.z.s + ')';
    if(animate && !REDUCE){ el.style.transition = 'transform .38s ' + FLY; requestAnimationFrame(function(){ el.style.transform = t; }); setTimeout(function(){ el.style.transition = ''; }, 400); }
    else el.style.transform = t;
    vw.classList.toggle('zoomed', st.z.s > 1.01);
  }
  function setZoom(s, px, py, animate){
    var old = st.z.s; s = clamp(s, 1, 4);
    if(s === 1){ st.z = { s:1, x:0, y:0 }; applyZoom(animate); return; }
    var k = s / old, nx = px - (px - st.z.x) * k, ny = py - (py - st.z.y) * k, b = bounds(s);
    st.z = { s:s, x:clamp(nx, -b.x, b.x), y:clamp(ny, -b.y, b.y) }; applyZoom(animate);
  }
  function rel(e){ var r = zw(st.i).getBoundingClientRect(); return [e.clientX - (r.left + r.width / 2) + st.z.x, e.clientY - (r.top + r.height / 2) + st.z.y]; }
  function gestures(){
    var vs = q('.vstage'), pts = new Map(), g = null, lastTap = 0, fx = 0, fy = 0, fRaf = null;
    vs.addEventListener('pointerdown', function(e){
      if(!st) return;
      pts.set(e.pointerId, [e.clientX, e.clientY]); cancelAnimationFrame(vSlide.raf);
      if(pts.size === 2){ var a = arr(pts.values()); g = { mode:'pinch', d0:Math.hypot(a[0][0] - a[1][0], a[0][1] - a[1][1]), s0:st.z.s, mid:[(a[0][0] + a[1][0]) / 2, (a[0][1] + a[1][1]) / 2] }; return; }
      g = { mode:null, x0:e.clientX, y0:e.clientY, bx:st.x, zx:st.z.x, zy:st.z.y, hist:[[e.clientX, e.clientY, performance.now()]] };
    });
    vs.addEventListener('pointermove', function(e){
      if(!st) return;
      if(pts.has(e.pointerId)) pts.set(e.pointerId, [e.clientX, e.clientY]);
      if(g && g.mode === 'pinch' && pts.size === 2){
        var a = arr(pts.values()), d = Math.hypot(a[0][0] - a[1][0], a[0][1] - a[1][1]), r = zw(st.i).getBoundingClientRect();
        setZoom(g.s0 * d / g.d0, g.mid[0] - (r.left + r.width / 2) + st.z.x, g.mid[1] - (r.top + r.height / 2) + st.z.y, false); return;
      }
      if(g && pts.has(e.pointerId)){
        var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
        g.hist.push([e.clientX, e.clientY, performance.now()]); if(g.hist.length > 5) g.hist.shift();
        if(!g.mode && Math.hypot(dx, dy) > 6){ g.mode = st.z.s > 1.01 ? 'pan' : (Math.abs(dx) > Math.abs(dy) ? 'swipe' : (dy > 0 && !wide.matches ? 'dismiss' : 'none')); try{ vs.setPointerCapture(e.pointerId); }catch(_){} }
        if(g.mode === 'pan'){ var b = bounds(st.z.s); st.z.x = clamp(g.zx + dx, -b.x - 40, b.x + 40); st.z.y = clamp(g.zy + dy, -b.y - 40, b.y + 40); applyZoom(false); }
        else if(g.mode === 'swipe'){ var min = -(st.list.length - 1) * VW(), v = g.bx + dx; if(v > 0) v *= .35; else if(v < min) v = min + (v - min) * .35; vSetX(v); }
        else if(g.mode === 'dismiss'){ var k = clamp(dy / 400, 0, 1); zw(st.i).style.transform = 'translate(' + dx * .6 + 'px,' + dy + 'px) scale(' + (1 - k * .3) + ')'; var bg = q('.bgg-bd'); bg.getAnimations().forEach(function(x){ x.cancel(); }); bg.style.opacity = 1 - k * .9; vw.classList.toggle('ready', k < .08); }
        return;
      }
      /* souris : l'image zoomée suit le pointeur en douceur */
      if(e.pointerType === 'mouse' && st.z.s > 1.01){
        var rr = vs.getBoundingClientRect(), bb = bounds(st.z.s);
        fx = -((e.clientX - rr.left) / rr.width - .5) * 2 * bb.x; fy = -((e.clientY - rr.top) / rr.height - .5) * 2 * bb.y;
        if(!fRaf) (function loop(){ if(!st){ fRaf = null; return; } st.z.x += (fx - st.z.x) * .14; st.z.y += (fy - st.z.y) * .14; applyZoom(false); fRaf = (st.z.s > 1.01 && (Math.abs(fx - st.z.x) > .3 || Math.abs(fy - st.z.y) > .3)) ? requestAnimationFrame(loop) : null; })();
      }
    });
    function end(e){
      pts.delete(e.pointerId);
      if(!g || !st) { g = null; return; }
      if(g.mode === 'pinch'){ if(pts.size < 2){ if(st.z.s < 1.05) setZoom(1, 0, 0, true); g = null; } return; }
      var h = g.hist, a = h[0], b = h[h.length - 1], dt = Math.max(1, b[2] - a[2]), vx = (b[0] - a[0]) / dt, vy = (b[1] - a[1]) / dt;
      var dx = b[0] - g.x0, dy = b[1] - g.y0, mode = g.mode; g = null;
      if(mode === 'swipe'){ var i = st.i; if(dx < -VW() * .18 || vx < -.45) i++; else if(dx > VW() * .18 || vx > .45) i--; vGo(i, clamp(520 - Math.abs(vx) * 200, 280, 520)); return; }
      if(mode === 'pan'){ var bb = bounds(st.z.s); st.z.x = clamp(st.z.x + vx * 120, -bb.x, bb.x); st.z.y = clamp(st.z.y + vy * 120, -bb.y, bb.y); applyZoom(true); return; }
      if(mode === 'dismiss'){
        var el = zw(st.i);
        if(dy > 120 || vy > .6){ var ir = vImg(st.i).getBoundingClientRect(); el.style.transform = ''; close(ir); }
        else { el.style.transition = 'transform .4s cubic-bezier(.34,1.56,.64,1)'; el.style.transform = ''; setTimeout(function(){ el.style.transition = ''; }, 420); var bg = q('.bgg-bd'); bg.style.opacity = ''; bg.animate([{ opacity:getComputedStyle(bg).opacity }, { opacity:1 }], { duration:250, fill:'forwards' }); vw.classList.add('ready'); }
        return;
      }
      if(!mode && e.type === 'pointerup'){
        var hit = D.elementFromPoint(e.clientX, e.clientY), onImg = hit && hit.closest && hit.closest('.vsl img'), now = performance.now(), touch = e.pointerType !== 'mouse';
        if(!onImg){ if(!touch) close(); return; }
        if(touch){ if(now - lastTap < 300){ lastTap = 0; var p = rel(e); setZoom(st.z.s > 1.01 ? 1 : 2.5, p[0], p[1], true); } else lastTap = now; }
        else { var p2 = rel(e); setZoom(st.z.s > 1.01 ? 1 : 2.5, p2[0], p2[1], true); }
      }
    }
    vs.addEventListener('pointerup', end); vs.addEventListener('pointercancel', end);
    vs.addEventListener('wheel', function(e){ if(!st) return; e.preventDefault(); var p = rel(e); setZoom(st.z.s * (e.deltaY < 0 ? 1.25 : .8), p[0], p[1], true); }, { passive:false });
    vs.addEventListener('dragstart', function(e){ e.preventDefault(); });
  }

  /* la visionneuse du thème (PhotoSwipe) est remplacée : on intercepte son ouverture */
  D.addEventListener('lightbox:open', function(e){
    var g = e.target && e.target.closest && e.target.closest('media-gallery.bgg');
    if(!g || !g._bgg) return;
    var idx = e.detail && typeof e.detail.index === 'number' ? e.detail.index : 0;
    if(open(g, Math.max(0, idx))){ e.stopImmediatePropagation(); e.stopPropagation(); }
  }, true);

  function initAll(){ arr(D.querySelectorAll('media-gallery')).forEach(function(g){ if(!g.closest('[data-bgg-off]')) initGallery(g); }); }
  window.BGG = { init:initAll, open:open };
  /* 04/10 (vitesse) : le CSS (assets/bgcom-gallery.css, <link id="bgg-css" media="print"> dans snippets/bgcom-gallery) arrive sans bloquer
     la page ; on attend qu'il soit appliqué avant de poser .bgg. S'il ne vient pas, la galerie du thème reste telle quelle. */
  function whenCss(fn){
    var l = D.getElementById('bgg-css');
    if(!l || l.media !== 'print'){ fn(); return; }
    var go = function(){ l.removeEventListener('load', go); fn(); };
    l.addEventListener('load', go);
  }
  function boot(){ whenCss(initAll); }
  if(D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', initAll);
})();
